import { render, staticRenderFns } from "./favorite-products-user-reg-form.vue?vue&type=template&id=48d2d272&scoped=true&"
import script from "./favorite-products-user-reg-form.ts?vue&type=script&lang=ts&"
export * from "./favorite-products-user-reg-form.ts?vue&type=script&lang=ts&"
import style0 from "./favorite-products-user-reg-form.scss?vue&type=style&index=0&id=48d2d272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2d272",
  null
  
)

export default component.exports